import { computed, nextTick, ref } from 'vue'
import moment from 'moment'
import Schema from 'async-validator'
import { Message } from 'view-design'
import { clone } from '@/common/js/just.js'
import budgetFormRules from '../../model/budget/budget-rules.js'
import { marketingGoalRules } from '../../model/project-rules.js'
import { getV3PlanForm, getTargetingForm, getMaterialTagForm } from '@/views/create/gdt/model/project-form.js'
import { budgetForm as budgetFormModel } from '@/views/create/gdt/model/budget/budget-form.js'
import { mergeDeep } from '@/common/js/utils'
import { SMART_DELIVERY_PLATFORM } from '../../model/project-const'
import { SMART_DELIVERY_GOAL, SMART_DELIVERY_GOAL_APP_LIST, SMART_DELIVERY_GOAL_LIST } from '../../model/budget/budget-const'
export const useProjectConfigForm = (configForm) => {
  const formRef = ref(null)

  const showBasicModal = ref(false)

  const methods = {
    /**
     * @description: 关闭抽屉弹窗表单前的校验
     * @return {*}
     */
    formValidator: (done) => {
      formRef.value
        .validate()
        .then(done)
        .catch((e) => {
          const errorElement = document.querySelector('.project-form .el-form-item__error')
          errorElement?.scrollIntoView({ block: 'center', behavior: 'smooth' })
          console.log('validate error output: ', e)
        })
    },
    /**
     * @description: 供父组件调用
     * @return {*}
     */
    async validate() {
      const descriptor = marketingGoalRules.call({ ...configForm.value })
      // const budgetDescriptor = budgetFormRules.call({ ...configForm.value })
      const validator = new Schema(descriptor)
      // const budgetValidator = new Schema(budgetDescriptor)
      try {
        await validator.validate(configForm.value.planForm)
        // await budgetValidator.validate(configForm.value.budgetForm)
        return Promise.resolve()
      } catch ({ errors, fields }) {
        console.log('errors output: ', errors)
        console.log('fields output: ', fields)

        return Promise.reject(new Error(0))
      }
      // return Promise.resolve()
    },

    getFormFileds: () => formRef.value.getForm(),
    setFormFileds: (form) => formRef.value.setForm(form),

    /**
     * @description: 打开弹窗，如果是编辑模式，将表单数据填充
     */
    onShowConfigModal: () => {
      if (!configForm.value.accounts?.length) {
        return Message.warning('请先添加账号')
      }
      showBasicModal.value = true

      // 如果已存在配置信息，直接覆盖
      const { planForm: plan, budgetForm: budget } = configForm.value

      // 兼容老模板没有配置激活的情况
      if (plan.smart_delivery_platform === SMART_DELIVERY_PLATFORM.GAME_APP) {
        // 如果老模板smart_delivery_platform是游戏应用智投且smart_delivery_goal不下下列中的一个，就给一个默认激活和首日付费ROI
        const smartDeliGameAppGoals = SMART_DELIVERY_GOAL_APP_LIST.map((item) => item.value)
        if (!smartDeliGameAppGoals.includes(budget.smart_delivery_goal)) {
          budget.smart_delivery_goal = SMART_DELIVERY_GOAL.GAME_APP_ACTIVATE_ROI_1DAY
        }
      }

      if (plan.smart_delivery_platform === SMART_DELIVERY_PLATFORM.MINI_GAME_PROMOTION) {
        // 小游戏跑量同理：smart_delivery_goal 不在可选列表中时回落到 7日付费ROI
        const smartDeliMiniGameGoals = SMART_DELIVERY_GOAL_LIST.map((item) => item.value)
        if (!smartDeliMiniGameGoals.includes(budget.smart_delivery_goal)) {
          budget.smart_delivery_goal = SMART_DELIVERY_GOAL.SEVEN_DAY_PURCHASE_ROI
        }
      }

      nextTick(() => {
        // 避免数据引用导致修改配置还未确认之前预览数据也被修改，克隆一份表单内容进行再次修改
        const planForm = plan?.project_name ? mergeDeep(getV3PlanForm(), plan) : getV3PlanForm()
        const startDate = moment().format('YYYY-MM-DD')
        const endDate = moment().add(1, 'years').format('YYYY-MM-DD')
        const budgetForm =
          budget && Object.keys(budget).length
            ? { ...clone(mergeDeep(budgetFormModel, budget)) }
            : { ...clone(budgetFormModel), rangeDate: [startDate, endDate] }
        // 把账号信息带入广告表单，兼容老的v3个版本
        planForm.accounts = configForm.value.accounts.map(({ id }) => id)
        formRef.value.setForm(planForm, budgetForm)
      })
    }
  }

  return { formRef, showBasicModal, methods }
}
